import { ChatIcon, LinkIcon } from '@chakra-ui/icons';
import { Box, Button, ButtonGroup, Collapse, Flex } from '@chakra-ui/react';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { useWebFormProps } from '../../hooks/useWebFormProps';
import { useQuestionItem } from './context';
import { QuestionAttachmentPane } from './QuestionAttachmentPane';
import { QuestionCommentPane } from './QuestionCommentPane';

const QuestionPane: React.FC<{ pane: string }> = ({ pane, children }) => {
  const { activePanes } = useQuestionItem();

  const isOpen = React.useMemo(
    () => activePanes.includes(pane),
    [pane, activePanes],
  );
  return (
    <Collapse in={isOpen}>
      <Flex bg="gray.50" borderTopWidth="thin" p="3" flex="1" mt="2" minH="10">
        {children}
      </Flex>
    </Collapse>
  );
};

export const QuestionAppend: React.FC<{ disableAttachements?: boolean }> = ({
  disableAttachements,
}) => {
  const { t } = useTranslation();
  const { itemId } = useWebFormProps();

  const { togglePane, activePanes } = useQuestionItem();

  return (
    <Flex borderTopWidth="thin" w="full" flexDir="column">
      {!disableAttachements && (
        <>
          <ButtonGroup p="3.5">
            {!!itemId && (
              <Button
                variant="outline"
                size="md"
                isActive={activePanes.includes('attachments')}
                leftIcon={<LinkIcon />}
                onClick={() => togglePane('attachments')}
              >
                {t('common.attachments')}
              </Button>
            )}
            <Button
              variant="outline"
              size="md"
              leftIcon={<ChatIcon />}
              isActive={activePanes.includes('notes')}
              onClick={() => togglePane('notes')}
            >
              {t('common.comment')}
            </Button>
          </ButtonGroup>
          <Box w="full">
            <QuestionPane pane="attachments">
              <QuestionAttachmentPane />
            </QuestionPane>
            <QuestionPane pane="notes">
              <QuestionCommentPane />
            </QuestionPane>
          </Box>
        </>
      )}
    </Flex>
  );
};
